import { Avatar, Box, Card, Stack, Typography } from "@mui/material";
import { Coach, COACHES } from "./shared";

function FighterCard({ coach }: { coach: Coach }) {
  return (
    <Card
      sx={{ p: 3, border: "2px solid", borderColor: "primary.main", height: "100%" }}
    >
      <Avatar
        src={coach.img}
        alt={coach.name}
        sx={{
          width: 120,
          height: 120,
          mx: "auto",
          mb: 2,
          border: "3px solid",
          borderColor: "primary.main",
        }}
      />
      <Typography variant="h5" align="center" gutterBottom>
        {coach.name}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {coach.bio1}
      </Typography>
      <br />
      <Typography variant="body1" color="text.secondary">
        {coach.bio2}
      </Typography>
    </Card>
  );
}

export function CoachesPage() {
  return (
    <Box sx={{ px: { xs: 3, md: 8 }, pt: { xs: 4, md: 6 }, pb: { xs: 4, md: 8 } }}>
      <Typography variant="h2" align="center" sx={{ mb: 4 }}>
        Nos instructeurs
      </Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={4} alignItems="stretch">
        {COACHES.map((coach) => (
          <Box key={coach.name} flex={1}>
            <FighterCard coach={coach} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
